import React, { forwardRef } from 'react';
import ReactPlayer from 'react-player';

const NewVideoPlayer = forwardRef(({ url, controls = true, ...rest }, ref) => {
  return (
    <div
      style={{
        position: 'relative',
        paddingTop: '56.25%',
        width: '100%',
        borderRadius: '8px',
        overflow: 'hidden',
      }}
    >
      <ReactPlayer
        ref={ref}
        url={url}
        controls={controls}
        width="100%"
        height="100%"
        style={{ position: 'absolute', top: 0, left: 0, borderRadius: '8px', objectFit: 'cover' }}
        config={{
          file: {
            attributes: {
              crossOrigin: 'anonymous',
              controlsList: 'nodownload',
              onContextMenu: (e) => e.preventDefault(),
              preload: 'auto',
              style: {
                objectFit: 'cover',
                width: '100%',
                height: '100%',
              },
            },
          },
        }}
        progressInterval={100}
        {...rest}
      />
    </div>
  );
});

export default NewVideoPlayer;
